import type { NeoInsightLatest } from 'src/hooks/useNeoInsights'

/**
 * Cascade 3PL — Insights surface for the canonical 3PL demo persona.
 * Morning rollup is the first thing Jordan sees when the platform opens:
 * eight agents ran overnight, the carrier claims queue is current, the
 * post-shipment monitor flagged the cases worth Jordan's judgment.
 */
export const cascade3plInsight: NeoInsightLatest = {
  id: 'demo-insight-cascade-3pl-2026-05-19',
  type: 'DAILY',
  status: 'ACTIVE',
  userEmail: null,
  summaryText:
    'Overnight, **eight agents ran on schedule.** Trailmix and Briar bulk-ship runs printed 5,350 labels across 2 facilities by 10:02am. The carrier claims agent **filed 11 claims** at 7am with the right evidence packages ($1,470 in motion). The post-shipment monitor **caught 285 in-transit exceptions**, auto-sent 220 customer notices, and escalated 38 cases. The top escalation: a Northwind shipment for Riley K. has been sitting at UPS Cleveland for four days — a customer notice is drafted and a replacement is pre-staged to fire in 48 hours if still undelivered.',
  generatedAt: new Date().toISOString(),
  startDate: null,
  endDate: null,
  insights: {
    recommendations: [
      {
        id: 'cascade-rec-morning-rollup',
        title:
          'This morning: 5,350 labels printed, 11 claims filed, 285 exceptions handled',
        description:
          "Eight agents ran on schedule overnight and through the early morning. Trailmix bulk-ship printed 3,200 labels at 10:02am; Briar Coffee bulk-ship printed 2,150 at 8:01am. The carrier claims agent filed 11 claims at 7am ($1,470 in motion). The post-shipment monitor caught 285 in-transit exceptions, sent 220 proactive customer notices, and escalated 38 cases (high-value customer, dollar amount over $500, or brand-wide pattern). The top escalation: a UPS shipment to Riley K. (Northwind Apparel) hasn't scanned in 4 days — customer notice drafted, replacement pre-staged to auto-fire in 48 hours.",
        priority: 'high',
        category: 'reliability',
        dataPoints: [
          'Trailmix bulk-ship: 3,200 labels printed at 10:02am (12 min run, Indy)',
          'Briar Coffee bulk-ship: 2,150 labels printed at 8:01am (9 min run, Atlanta)',
          'Carrier claims agent: 11 claims filed at 7am ($1,470 in motion)',
          'Post-shipment monitor: 285 exceptions caught, 220 customer notices auto-sent, 38 escalations',
        ],
        actionableSteps: [
          'Review the 38 escalations queued in the Post-Shipment Monitor',
          'Confirm the Riley K. customer notice (drafted) is in Cascade voice',
          'Glance at the agents tab — no failed runs across the network in 30 days',
        ],
        estimatedImpact:
          'Reclaimed roughly 6 hours of morning routine across the network. 220 customer questions never asked. $1,470 of carrier recovery in motion before 8am.',
      },
    ],
  },
}
